import React from "react";
import ReactPlayer, {Config} from "react-player";
import {ProgramPages} from "../../types";

export const IS_IOS_DEVICE =
    typeof navigator !== "undefined" && /iPad|iPhone|iPod/.test(navigator.userAgent);

export const PlayerConfig: Config = {
    file: {
        forceHLS: false,
        forceSafariHLS: true,
        attributes: {
            controlsList: "nodownload",
            disablePictureInPicture: true,
            playsInline: true,
            webkitplaysinline: "true",
            "x-webkit-airplay": "allow",
            autoPlay: true,
        },
    },
};

export const isRealtimeContentType = (
    value?: string
): value is typeof ProgramPages.LIVE | typeof ProgramPages.SPORTS =>
    value === ProgramPages.LIVE || value === ProgramPages.SPORTS;

export const isIOSIPhone = (): boolean => {
    if (typeof navigator === "undefined") return false;
    const ua = navigator.userAgent;
    return /iPhone/.test(ua) && /WebKit/.test(ua);
};

export const getVideoElement = (
    playerRef: React.RefObject<ReactPlayer>
): HTMLVideoElement | null => {
    const internal = playerRef.current?.getInternalPlayer?.() as HTMLVideoElement | null;
    if (internal instanceof HTMLVideoElement) return internal;
    return (playerRef.current as any)?.wrapper?.querySelector?.("video") ?? null;
};
